import React from "react";
import "./Footer.css";
import ScrollService from "../../utilities/ScrollService";
import Wave from '../../assets/Footer/wave.png';
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";
import { FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export default function Footer() {
  return (
  <div>  

<div className="footer mt-4">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <FontAwesomeIcon icon="fa-brands fa-square-facebook" />
      <div className="f-content">
        <span className='mt-5 ft_name'>H.M Merajul Hasan</span>
        <span className="ft_address">Dhaka,Bangladesh</span>
        <span className="contact_add"><span className="email_col">Email: </span> hmmerajulhasan@gmail.com  ||  <span className="whatsapp_col">Whatsapp:</span> +880 1704357909</span>
        <div className="f-icons">
         <a href="https://www.facebook.com/merajoulehasan.utsho" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="facebook"><Facebook color="purple" size={"3rem"} /></a> 
         <a href="https://www.instagram.com/h_m_merajoule_hasasn/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Instagram"><Insta color="purple" size={"3rem"} /></a>
         <a href="https://github.com/HNMerajulhasan" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Github"><Gitub color="purple" size={"3rem"} /></a>   
         <a href="https://www.linkedin.com/in/h-m-merajul-hasan-62687b23a/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="linkedin">
              <i className="fa fa-linkedin  fa_linke" />
          </a>
        </div>
       <hr/>
       <p className="footer_copyright">© Meraj-The-Web-Doctor, All Right Reserved 2022 | Designed By H.M Merajul Hasan</p>
      </div>
     
    </div>
   

    <div className="scroll-container">
      <button
        className="btn-scroll"
        onClick={() => ScrollService.scrollHandler.scrollToHome()}
      >
        {" "}
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
   </div>
  );
}